import React from 'react';
import Sidebar from './Sidebar';
import { useSidebar } from '../context/SidebarContext';
import { Menu } from 'lucide-react';

export default function Layout({ children }) {
  const { collapsed, mobileOpen, setMobileOpen } = useSidebar();

  return (
    <div className="min-h-screen" style={{ background: '#09090B' }}>
      {/* Mobile backdrop */}
      {mobileOpen && (
        <div
          data-testid="sidebar-backdrop"
          className="fixed inset-0 bg-black/60 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      <Sidebar />

      <main
        className={`min-h-screen transition-all duration-300 ${
          collapsed ? 'md:ml-16' : 'md:ml-60'
        } ml-0`}
      >
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center h-12 px-4 sticky top-0 z-30"
          style={{ background: '#09090B', borderBottom: '1px solid #27272A' }}>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setMobileOpen(true)}
            className="p-1.5 rounded text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800"
          >
            <Menu size={20} />
          </button>
          <span className="ml-3 text-sm font-semibold text-zinc-200" style={{ fontFamily: 'Outfit, sans-serif' }}>
            PointEdge
          </span>
        </div>

        <div className="p-4 md:p-6 max-w-[1400px]">{children}</div>
      </main>
    </div>
  );
}
